(() => {
  const content = document.getElementById('cm-content');
  if (!content) return;
  const runtime = () => window.CovermaticRuntime;
  function start(mode = 'custom', focus = 'artist') {
    const flow = runtime()?.getService('flow');
    if (!flow) return;
    if (mode === 'premade') flow.openSignatureCoverPicker();
    else if (mode === 'promo') flow.openPromoGraphicsPicker();
    else {
      flow.startCustom();
      document.getElementById('cover-creator').scrollIntoView({block: 'start', behavior: matchMedia('(prefers-reduced-motion: reduce)').matches ? 'auto' : 'smooth'});
      document.getElementById(focus)?.focus({preventScroll: true});
    }
  }
  content.querySelectorAll('[data-start-creating],[data-start-photo],[data-open-mode]').forEach(button => button.addEventListener('click', event => {
    event.preventDefault();
    start(button.dataset.openMode || 'custom', 'artist');
  }));
  content.querySelectorAll('[data-use-brief]').forEach(button => button.addEventListener('click', async () => {
    start();
    if (!button.dataset.templateTitle) runtime()?.getService('form')?.clearTemplate?.();
    if (button.dataset.templateTitle) await window.CovermaticApp.modals.selectTemplate({title: button.dataset.templateTitle, imageUrl: button.dataset.templateImage});
    const concept = document.getElementById('concept');
    concept.value = document.getElementById(`brief-${button.dataset.useBrief}`).textContent.trim();
    concept.dispatchEvent(new Event('input', {bubbles: true}));
    concept.focus({preventScroll: true});
  }));
  content.querySelectorAll('[data-select-template]').forEach(button => button.addEventListener('click', async () => {
    start();
    await window.CovermaticApp.modals.selectTemplate({title: button.dataset.templateTitle, imageUrl: button.dataset.templateImage});
    document.getElementById('artist')?.focus({preventScroll: true});
  }));
  content.querySelectorAll('[data-thumb-size]').forEach(button => button.addEventListener('click', () => {
    const size = Number(button.dataset.thumbSize), image = document.getElementById('cm-thumbnail-example');
    image.style.width = image.style.height = `${size}px`;
    content.querySelectorAll('[data-thumb-size]').forEach(item => item.setAttribute('aria-pressed', String(item === button)));
    document.getElementById('thumb-status').textContent = `Viewing at ${size} pixels`;
  }));
  content.querySelectorAll('.cm-faq-item button').forEach(button => button.addEventListener('click', () => {
    const expanded = button.getAttribute('aria-expanded') === 'true';
    button.setAttribute('aria-expanded', String(!expanded));
    document.getElementById(button.getAttribute('aria-controls')).hidden = expanded;
  }));
  document.addEventListener('DOMContentLoaded', () => {
    const mode = new URLSearchParams(location.search).get('mode');
    if (mode === 'premade' || mode === 'promo') start(mode);
    else if (!new URLSearchParams(location.search).has('premade_template')) runtime()?.getService('flow')?.startCustom();
  });
})();
